<div class="search-container">
  <input
    type="text"
    class="form-control"
    [value]="(selectedPatient?.id ?? selectedPatient?._id) ?? savedPatientId"
    readonly
    [placeholder]="'patient-card.search-input' | translate"
  />
  <div class="icon-container">
    <button
      class="icon-button"
      (click)="clearSearch()"
      *ngIf="(selectedPatient?.id || savedPatientId) && !isApproved && !delete"
    >
      <i class="fa-solid fa-xmark"></i>
    </button>
    <button *ngIf="!isApproved && !delete" class="icon-button" (click)="search()">
      <i class="fa-solid fa-magnifying-glass"></i>
    </button>
    <button
      *ngIf="!delete"
      class="icon-button"
      (click)="createPatient()"
    >
      <i class="fa-solid fa-plus"></i>
    </button>
    <button
      *ngIf="(selectedPatient?.id || savedPatientId) && !disabledInfoButton"
      class="icon-button"
      (click)="showDetails()"
    >
      <i class="fa-solid fa-circle-info"></i>
    </button>
  </div>
</div>

<p-dialog
  [header]="'patient-card.dialog-header' | translate"
  [(visible)]="isOpen"
  [modal]="true"
  [style]="{ width: '70vw' }"
  (onHide)="clearFilter()"
  appendTo="body"
>
  <div class="filter-container">
    <div class="row mb-1">
      <div class="col-xl-3">
        <label for="tckn">{{ "patient-card.id-number" | translate }}</label>
        <input
          id="tckn"
          type="text"
          class="form-control"
          [placeholder]="'patient-card.id-number' | translate"
          [(ngModel)]="filters.tckn"
        />
      </div>
      <div class="col-xl-3">
        <label for="passport-no">{{
          "patient-card.passport-no" | translate
        }}</label>
        <input
          id="passport-no"
          type="text"
          class="form-control"
          [placeholder]="'patient-card.passport-no' | translate"
          [(ngModel)]="filters.passportNo"
        />
      </div>
      <div class="col-xl-3">
        <label for="name">{{ "patient-card.name" | translate }}</label>
        <input
          id="name"
          type="text"
          class="form-control"
          [placeholder]="'patient-card.name' | translate"
          [(ngModel)]="filters.name"
        />
      </div>
      <div class="col-xl-3">
        <label for="surname">{{ "patient-card.surname" | translate }}</label>
        <input
          id="surname"
          type="text"
          class="form-control"
          [placeholder]="'patient-card.surname' | translate"
          [(ngModel)]="filters.surname"
        />
      </div>
      <div class="col-xl-3">
        <label for="gender">{{ "patient-card.gender" | translate }}</label>
        <p-dropdown
          [options]="genders"
          [(ngModel)]="filters.gender"
          [placeholder]="'patient-card.gender' | translate"
          appendTo="body"
        >
        </p-dropdown>
      </div>
      <div class="col-xl-3">
        <label for="dob">{{ "patient-card.birth-date" | translate }}</label>
        <p-calendar
          dateFormat="dd.mm.yy"
          [(ngModel)]="filters.birthDate"
          [placeholder]="'patient-card.birth-date' | translate"
          [showTime]="false"
          [showButtonBar]="true"
          appendTo="body"
        />
      </div>
      <div class="col-xl-3 mb-1">
        <label for="phone">{{ "patient-card.phone" | translate }}</label>
        <input
          id="phone"
          type="text"
          class="form-control"
          [placeholder]="'patient-card.warning' | translate"
          [(ngModel)]="filters.phone"
        />
      </div>
      <div class="col-xl-3 mt-4 d-flex  align-items-center filter-buttons">
        <button
          class="btn btn-danger light filter-btn"
          (click)="clearFilters()"
          type="button"
        >
          {{ "general.clear-filter" | translate }}
        </button>
        <button
          (click)="loadData({first,rows})"
          class="btn btn-info ms-2 filter-btn"
          type="button"
        >
          {{ "general.filtering" | translate }}
          <i class="fa fa-search ms-2"></i>
        </button>
      </div>
    </div>
  </div>

  <div class="active-projects" *ngIf="!isFirtsTime">
    <p-table
      [value]="patients"
      [paginator]="true"
      [rowsPerPageOptions]="[10, 20, 30]"
      selectionMode="single"
      [(selection)]="selectedPatient"
      [rows]="rows"
      [first]="first"
      [scrollable]="true"
      [scrollHeight]="'40vh'"
      [totalRecords]="totalRecords"
      responsiveLayout="stack"
      [style]="{ width: '100%' }"
      (onPage)="loadData($event)"
      [lazy]="true"
    >
      <ng-template pTemplate="header">
        <tr>
          <th scope="col">{{ "patient-card.patient-no" | translate }}</th>
          <th scope="col">{{ "patient-card.id-number" | translate }}</th>
          <th scope="col">{{ "patient-card.passport-no" | translate }}</th>
          <th scope="col">{{ "patient-card.name" | translate }}</th>
          <th scope="col">{{ "patient-card.surname" | translate }}</th>
          <th scope="col">{{ "patient-card.gender" | translate }}</th>
          <th scope="col">{{ "patient-card.birth-date" | translate }}</th>
          <th scope="col">{{ "patient-card.category" | translate }}</th>
        </tr>
      </ng-template>
      <ng-template let-person pTemplate="body">
        <tr [pSelectableRow]="person">
          <td>{{ person?.id }}</td>
          <td>{{ person?.idNumber }}</td>
          <td>{{ person?.passportNo }}</td>
          <td>{{ person?.firstName }}</td>
          <td>{{ person?.lastName }}</td>
          <td>{{ person?.gender | gender }}</td>
          <td>{{ person?.birthDate | date : "dd.MM.yyyy" }}</td>
          <td>
            <i
              *ngIf="person?.category?.length > 0"
              class="fa-solid fa-circle-info category-logo"
              (click)="op.toggle($event); $event.stopPropagation()" role="button"  tabindex="-1"
            ></i>

            <p-overlayPanel #op>
              <ng-template pTemplate="content">
                <div class="badge-container">
                  <span
                    class="badge bg-purple"
                    *ngFor="let category of person?.category"
                  >
                    {{ category?.valueObject?.name?.value }}
                  </span>
                </div>
              </ng-template>
            </p-overlayPanel>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="paginatorleft">
        {{ totalRecords }} Adet Bulundu
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="99">
            {{ "common.noData" | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <ng-template pTemplate="footer">
    <div class="d-flex align-items-center">
      <div>
        <button class="btn btn-danger me-2" (click)="isOpen = false">
          {{ "common.cancel" | translate }}
        </button>
        <button
          class="btn btn-success"
          [disabled]="!selectedPatient"
          (click)="confirmSelection()"
        >
          {{ "patient-card.continue" | translate }}
        </button>
      </div>
    </div>
  </ng-template>
  <app-loading [fullScreen]="true" [loading]="loading"></app-loading>

</p-dialog>

<ng-template #patientCreate></ng-template>
